import { render, staticRenderFns } from "./OutOfStockReport.vue?vue&type=template&id=317580b1&"
import script from "./OutOfStockReport.vue?vue&type=script&lang=js&"
export * from "./OutOfStockReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports